import type { ReactNode } from 'react';
import { cn } from '@library/component-utils/cn';

interface PageBodyProps {
  children: ReactNode;
  className?: string;
}

export const PageBody = ({ children, className = '' }: PageBodyProps) => {
  return <div className={cn('p-6', className)}>{children}</div>;
};
